import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import AssemblyInformation from "./AssemblyInformation";
import GridConfig from "../GridConfig";

export default class AssemblyInformations extends Base {
    constructor(props) {
        super(props);
        this.state = {
            buildingId: props.BuildingId,
            caller: props.Caller,
            controllerName: 'buildingassemblyinformation',
            IsV2: true,
            data: null,
            loading: true,
            configName: 'buildingassemblyinformation_grid',
            moduleName: 'تشکیل مجامع ساختمان ها'
        };
        this.state.filters = {
            buildingId: this.state.buildingId
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <AssemblyInformation BuildingId={this.state.buildingId} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <AssemblyInformation BuildingId={this.state.buildingId} Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "dateHoldingString", caption: "تاریخ برگزاری", show: true },
                { field: "textMeeting", caption: "موضوع جلسه", show: true },
                { field: "number", caption: "شماره جلسه", show: true },
                { field: "addressHolding", caption: "محل برگزاری", show: true },
                { field: "createDateString", caption: "تاریخ ثبت", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'dateHoldingString' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.dateHoldingString}</a> } });
            if (f.field == 'textMeeting' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 4 });
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'addressHolding' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });

        t.push({
            field: "", filter: false, flex: 1, headerName: "عملیات", cellRenderer: (props) => {
                return <ul className="flex flex-row">
                    <li>
                        <a className="btn btn-trigger btn-icon hand" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                            <em className="icon ni ni-cross-fill-c"></em>
                        </a>
                    </li>
                </ul>
            }
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">مجامع</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: true, print: false, pdf: false, excell: false, remove: false, config: false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}